module.exports = __webpack_public_path__ + "img/users-left.98e30c38.svg";